module.exports = __webpack_public_path__ + "media/images/flags/nz-bc62fb4eb26dc5277f3d7e2d453f9860.svg";